import React from 'react';
import './List.css';
import Tooltip from '../tooltip/Tooltip';

function ListColorExtension({group = 0}) {
  return (
    group > 0 &&
    <React.Fragment>
      <Tooltip className={"listColorExtensionContainer"} text={`Team ${group}`}>
        <svg className={`listColorExtensionItem group${group}`} width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          {/* Isoceles right-triangle hugging the card's bottom-left corner.
              Card border-radius is 10px (outer) with a 1px border, so the
              inner curve has radius ~9. The container is positioned at
              left:-1 so SVG x=2 lands at the inner-left edge and SVG y=19
              at the inner-bottom edge. Both straight legs are 8 units long
              (top vertex (2,2) and bottom-right vertex (19,19)) so the
              hypotenuse runs at exactly 45° and the top/bottom-right corners
              are both 45°. */}
          <path d="M2 2 V 10 A 9 9 0 0 0 11 19 H 19 L 2 2 Z"/>
        </svg>
      </Tooltip>
    </React.Fragment>
  )
}

export default ListColorExtension